// extracted by mini-css-extract-plugin
export default {"sectionRoot":"IXTPWD6WnkazlrZowIDgPg==","sectionItems":"WBB86YMJhUSMHUE5Q+iVjA==","separator":"S07FiJgVH1tWDOpoq-FifA=="};